<template>
	<section class="insicht insicht--fade-up">
		<div class="vouchers__container">
			<GeneralMessage
				ref="initialError"
				v-if="initialError"
				:message="initialError"
				type="error"
			/>
			<div
				class="vouchers__content"
				v-if="content.text"
				v-html="content.text"
			/>
			<Button
				v-if="content.videoUrl"
				type="button"
				level="tertiary"
				:text="$t('vouchers.tutorialButton')"
				arrow
				@click.prevent="onVideoClick(content.videoUrl)"
			/>
		</div>
		<div class="vouchers__form">
			<GeneralMessage
				ref="message"
				v-if="response.message"
				:message="response.message"
				:type="response.type"
				stick
			/>

			<ValidationObserver
				ref="form"
				v-slot="{ invalid, errors }"
				tag="form"
				class="checkout-form__form-wrapper vouchers__form-wrapper"
				novalidate
				@submit.prevent="onSubmit"
			>
				<div class="input-row">
					<ValidationProvider
						class="input-row__wrapper"
						name="balanceCardNumber"
						rules="required"
						v-slot="{ errors, invalid, validated }"
						tag="div"
						:customMessages="{ required: $t('forms.errors.fieldEmpty') }"
					>
						<FormInput
							type="text"
							:placeholder="$t('vouchers.cardNumberLabel')"
							:label="$t('vouchers.cardNumberLabel')"
							v-model="form.cardNumber"
							:error="errors.length > 0"
							required
						/>
						<span
							class="input-error"
							v-if="invalid && validated"
							v-html="errors[0]"
						/>
						<span class="additional-info" v-html="$t('vouchers.cardNumberHint')"/>
					</ValidationProvider>
				</div>


				<Button
					type="submit"
					level="primary"
					:text="$t('vouchers.balanceButton')"
					:disabled="formLocked"
				/>
			</ValidationObserver>
		</div>
		<div class="vouchers__container">
			<div
				class="vouchers__voucher-value"
				v-if="balance != null"
			>
				<span v-html="$t('vouchers.balanceResultText', {balance: $options.filters.fwgpricecent(balance)})"/>
			</div>
		</div>

		<Modal
			ref="videoModal"
		>
			<div
				class="overlay-video"
				v-html="videoEmbedCode"
			/>
		</Modal>
	</section>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate"
import { mapGetters } from "vuex"
import FormInput from "@/components/FormInput"
import FormInputTextarea from "@/components/FormInputTextarea"
import FormInputCheckbox from "@/components/FormInputCheckbox"
import urlWatcher from '@/helpers/urlwatcher'
import GenericMixin from '@/mixins/GenericVueMixin'
import QuantityCounter from '@/components/QuantityCounter';
import Button from '@/components/Button'
import GeneralMessage from '@/components/GeneralMessage'
import Modal from '@/components/Modal'
import videoEmbed from '@/utils/videoEmbed'

export default {
	mixins: [
		GenericMixin,
	],
	components: {
		ValidationProvider,
		ValidationObserver,
		FormInput,
		FormInputTextarea,
		FormInputCheckbox,
		Button,
		GeneralMessage,
		Modal,
		QuantityCounter
	},
	data() {
		return {
			initialError: this.$root.options.initialError,
			content: this.$root.options.content,
			config: this.$root.options.config,
			form: {
				cardNumber: '',
			},
			response: {
				type: 'info',
				message: '',
			},
			formLocked: false,
			videoEmbedCode: '',
		}
	},
	computed: {
		...mapGetters('loader', [
			'isLoading',
		]),
		...mapGetters('vouchers', [
			'balance',
		]),
		loading: {
			set(value) {
				this.$store.dispatch('loader/setLoading', value);
				this.$emit('loading', value);
			},
			get() {
				return this.isLoading;
			}
		}
	},
	methods: {
		onVideoClick(url) {
			this.videoEmbedCode = videoEmbed(url);
			this.$refs.videoModal.open();
		},
		async onSubmit(e) {
			e.preventDefault();

			const valid = await this.$refs.form.validate();

			if (valid) {
				this.loading = true;
				try {
					const response = await this.$store.dispatch('vouchers/checkVoucherBalance', {
						...this.form,
					});
				}
				catch(err) {
					if (err.response && err.response.data.message) {
						this.response.message = err.response.data.errors && err.response.data.errors.cardNumber
							? err.response.data.errors.cardNumber.join()
							: err.response.data.message
					} else {
						// this.response.message = error.message || this.$t('forms.errors.generic');
						this.response.message = this.$t('forms.errors.generic');
					}
					this.response.type = 'error';
					this.$nextTick(() => {
						this.$refs.message.scrollTo();
					});
				}

				this.loading = false;
			}
		},
		resetForm() {
			this.$refs.form && this.$refs.form.reset();
			this.form.cardNumber = '';
		},
	},
	created() {
		this.loading = true;
	},
	mounted() {
		this.loading = false;
	}
};
</script>

<style>
</style>
